import React from "react";

import { Card, CardContent } from "@/components/ui/card";

export default function SectionCard({ title, right, children }) {
  return (
    <Card className="glass">
      <CardContent className="p-0">
        <div className="flex items-center justify-between gap-3 px-4 py-3">
          <div className="text-lg font-semibold text-slate-100">{title}</div>
          {right ? <div className="flex items-center gap-2">{right}</div> : null}
        </div>
        <div className="border-t border-white/10 px-4 py-4">{children}</div>
      </CardContent>
    </Card>
  );
}
